export default function loginWithTags(loginFunction) {
  window.dataLayer.push({ 'event': 'sign-up-button-click' })
  loginFunction();
}